export enum EBetPositionErrorCode {
  /** услуга размещения не поддерживает позицию поиска **/
  serviceNotSupported = 'serviceNotSupported',
  /** адрес объявления не указан **/
  geoEmpty = 'geoEmpty',
  /** цена объявления не указана **/
  priceEmpty = 'priceEmpty',
  /** адрес и цена объявления не указаны **/
  priceAndGeoEmpty = 'priceAndGeoEmpty',
  /** достигнута минимальная ставка **/
  minimalBetReached = 'minimalBetReached',
  /** достигнута максимальная ставка **/
  maximalBetReached = 'maximalBetReached',
  /** ставка не кратна шагу **/
  betNotDivided = 'betNotDivided',
  /** ошибка на сервере **/
  serverError = 'serverError',
}
